import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import api from 'api/api';
import { ReleaseRef } from 'hooks/data/versions/types';
import { useResolvedRelease } from 'hooks/useVersionInfo';
import { isV4Release } from 'utilities/constants/versions';

import { Dataset, FetchDatasetParams } from './types';

const fetchDataset = async (params: FetchDatasetParams) => {
  const { data } = await api.get(`/spold`, { params });

  return data;
};

const useDataset = (id?: string, isShowingV4?: boolean, release?: ReleaseRef) => {
  const { version, system_model } = useResolvedRelease(release);
  const isV4 = release ? isV4Release(version) : Boolean(isShowingV4);

  return useQuery<Dataset, AxiosError>({
    queryKey: ['dataset', id, version, system_model],
    queryFn: () => fetchDataset({ dataset_id: id as string, version, system_model }),
    enabled: !isV4 && !!id,
    retry: false,
  });
};

export default useDataset;
